"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW_TYPES = exports.NOTIFICATION_CENTER = exports.DEFAULT_OPTIONS = exports.DEFAULT_DURATION = exports.ANIMATION_DURATION = void 0;
// milliseconds

// Time for alert shown before hiding
var DEFAULT_DURATION = 5000;

// Time for wait for animation ending to hide alert
exports.DEFAULT_DURATION = DEFAULT_DURATION;
var ANIMATION_DURATION = 150;
exports.ANIMATION_DURATION = ANIMATION_DURATION;
var DEFAULT_OPTIONS = {
  clearOtherAlerts: true,
  duration: DEFAULT_DURATION
};
exports.DEFAULT_OPTIONS = DEFAULT_OPTIONS;
var NOTIFICATION_CENTER = 'notification-center';
exports.NOTIFICATION_CENTER = NOTIFICATION_CENTER;
var VIEW_TYPES = {
  TOAST: 'toast',
  INLINE: 'inline',
  STATIC: 'static'
};
exports.VIEW_TYPES = VIEW_TYPES;